import sliceCreator from '../../index.jsx';
import {UPDATE_AREA} from '../../../constants/index.jsx';
const _updateAreaAction = sliceCreator('UPDATE_AREA', UPDATE_AREA, 'put');

const { asyncAction: updateAreaAction, reducer, clearData: clearUpdateAreaAction } = _updateAreaAction;

export default reducer;

export {
    updateAreaAction,
    clearUpdateAreaAction
}